import Cookie from 'services/Cookie';

export const APP_LOCALES = ['en', 'ca', 'eu', 'pt', 'es'];

export const readLocaleCookie = () => {
  const value = Cookie.get('locale');
  return typeof value === 'string' && APP_LOCALES.includes(value) ? value : null;
};

export const writeLocaleCookie = locale => {
  if (typeof locale === 'string' && APP_LOCALES.includes(locale)) {
    Cookie.set('locale', locale);
  }
};
